var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcludeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131 0.000275608H0.000275608V131C0.269135 58.7714 58.7714 0.269135 131 0.000275608Z",
    fill: "#FFFAF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcludeIcon);
export default __webpack_public_path__ + "static/media/Exclude-icon.a32933434fb5fbfecf34d891b5d9ecda.svg";
export { ForwardRef as ReactComponent };